export const HOME_ACTION_PERSIST = "HOME_PERSIST";
export const HOME_ACTION_CLEAR = "HOME_CLEAR";
